import React, { Component, Fragment } from 'react';
import { isEmpty } from "lodash"
import Spin from '../../../commonModules/interface/Spin';
import { BreadCrumb } from './containers/Layout';
import { Button, Grid, Box, IconButton } from '@material-ui/core';
import { ListRounded, ListAltRounded } from '@material-ui/icons';
import InputText, { InputSelect } from '../../../commonModules/interface/form-input-inline';
import CardPage from '../../../commonModules/layouts/CardPage';
import FormCredit from './credits/FormCredit';
import ListCredit from './credits/ListCredit.jsx';
import SingleShop from './shops/SingleShop';
import SingleSaleCredits from './credits/SingleSaleCredits';
import ListSale from './transfers/sales/ListTransferSale';
import AccordionFilter from './Filter/AccordionFilter';
import SingleTransferSale from './transfers/sales/SingleTransferSale';

class Credits extends Component{
    state = {
        view: this.props.new ? "new" : "list",
        listview: "credit",

        singleShop:{},
        singleCredit:{
            credit:{},
            shop:{},
            client:{},
            sale:{},
        },

        breadcrumb: "",
        currentPage: 0,
        currentPageSale: 0,
        rowsPerPage: 20,

        selectShop: "",
        searchType: "",
        searchClient: "",
        searchFacture: "",
        searchCredit: "", 
        searchSaleuct: "", 
        searchPointing: "",
        searchPaymentStatus: "",
    }
        
    componentDidMount = () => {
        if ( isEmpty(this.props.SALE_CREDITS) ){
            this.props.fetchSaleCredits()
        }
    }
    // select options 
        createShopList = () => {
            const list = [{value:"", label:"Tous les Magasins"}]
            const { SHOPS } = this.props
            if( !isEmpty(SHOPS) ){
                Object.values(SHOPS).forEach( shop => { 
                    list.push (       
                        {value:shop.id, label:shop.name} 
                    )
                })
            } 
            return list
        }
        createClientList = () => {
            const list = [{value:"", label:"Tous les Clients"}]
            const { CLIENTS } = this.props
            if( CLIENTS ){
                Object.values(CLIENTS).map(client => { 
                    list.push (       
                        {value:client.id, label:client.client_lastname} 
                    )
                })
            } 
            return list
        }
        handleChange = (e) => {
            const { name, value } = e.target;
            this.setState({
                [name]: value,
                currentPage: 0,
                currentPageSale: 0,
            })
        }
        handleSelect = (option, name) => {
            this.setState({
                [name]: option.value, 
                currentPage: 0,
                currentPageSale: 0,
            })
        } 

        getFilteredList = () => {
            const { SALE_CREDITS } = this.props;
            const { selectShop, searchClient, searchFacture, searchType } = this.state;
            
            let list = Object.values(SALE_CREDITS)
            
            // client
            if (!isEmpty(searchClient)) { 
                list = list.filter(item => item.client_ref === searchClient)
            }
            // type
            if(!isEmpty(searchType)){ 
                list = list.filter(item => item.nature === searchType)
            }
            // shop
            if(!isEmpty(selectShop)){  
                list = list.filter(item => item.shop_id === selectShop)
            }
            // fact
            if(!isEmpty(searchFacture)){
                const normalizeRef = (s) => (s || '').toString().toLowerCase().replace(/[-/\s_]/g, '');
                const search = normalizeRef(searchFacture);
                list = list.filter(item =>
                    normalizeRef(item.id).indexOf(search) > -1 ||
                    normalizeRef(item.intern_ref_id).indexOf(search) > -1
                );
            }
            return list
        }

        getFilteredListSale = () => {
            const { SALES, SALE_CREDITS } = this.props;
            const {
                selectShop,
                searchClient,
                searchFacture,
                searchType,
                searchPointing,
                searchPaymentStatus
            } = this.state;
            
            let list = Object.values(SALES).filter(sale => sale.sale_credit)
            const saleCredits = Object.values(SALE_CREDITS || {});
            const paymentStatsBySale = {};
            const paidTotalsBySale = {};

            saleCredits.forEach((credit) => {
                if (!credit || !credit.sale_id) return;
                const saleID = credit.sale_id;
                if (!paymentStatsBySale[saleID]) {
                    paymentStatsBySale[saleID] = { total: 0, pointed: 0 };
                }
                paymentStatsBySale[saleID].total += 1;
                const amount = parseFloat(credit.amount || 0) || 0;
                const amountLinked = parseFloat(credit.amount_linked || 0) || 0;
                const isFullyPointed = amountLinked >= amount || (amountLinked === 0 && (credit.income_id || credit.fact_id_5000));
                if (isFullyPointed) {
                    paymentStatsBySale[saleID].pointed += 1;
                }
                const paidAmount = amountLinked > 0 ? amountLinked : (credit.income_id ? amount : 0);
                paidTotalsBySale[saleID] = (paidTotalsBySale[saleID] || 0) + paidAmount;
            });
           
            // client
            if (!isEmpty(searchClient)) {
                list = list.filter(item => item.client_ref === searchClient || item.sale_paygo_id === searchClient )
            }
            // type
            if(!isEmpty(searchType)){
                list = list.filter(item => item.nature === searchType)
            }
            // shop
            if(!isEmpty(selectShop)){
                list = list.filter(item => item.shop_id === selectShop)
            }
            // fact
            if(!isEmpty(searchFacture)){
                const normalizeRef = (s) => (s || '').toString().toLowerCase().replace(/[-/\s_]/g, '');
                const search = normalizeRef(searchFacture);
                list = list.filter(item =>
                    normalizeRef(item.id).indexOf(search) > -1 ||
                    normalizeRef(item.intern_ref_id).indexOf(search) > -1
                );
            }
            // paiements non pointes
            if(!isEmpty(searchPointing) && (searchPointing === "unpointed" || searchPointing === "pointed")){
                list = list.filter((sale) => {
                    const stats = paymentStatsBySale[sale.id] || { total: 0, pointed: 0 };
                    let pointedCount = stats.pointed;
                    if (stats.total > 0 && pointedCount === 0 && sale.fact_id_5000) {
                        pointedCount = stats.total;
                    }
                    if (pointedCount > stats.total) {
                        pointedCount = stats.total;
                    }
                    const hasUnpointedPayments = stats.total > 0 && pointedCount < stats.total;
                    if (searchPointing === "unpointed") return hasUnpointedPayments;
                    return stats.total > 0 && !hasUnpointedPayments;
                });
            }
            // etat de paiement
            if(!isEmpty(searchPaymentStatus)){
                const EPSILON = 0.01;
                list = list.filter((sale) => {
                    const paidTotal = paidTotalsBySale[sale.id] || 0;
                    const totalToPay = parseFloat(sale.total_price_TTC ?? sale.total_price ?? 0) || 0;
                    const isFullyPaid = paidTotal + EPSILON >= totalToPay;
                    if (searchPaymentStatus === "full") return isFullyPaid;
                    if (searchPaymentStatus === "partial") return !isFullyPaid;
                    return true;
                });
            }
            return list
        }
        
    // CLEAR & DISPLAY
        handleClose = () => {
            this.setState({
                view:"list",
                breadcrumb: "",
            });
            // this.clearForms()
        }
        handleSingleCredit = (credit, shop, client, sale) => {
            this.setState({
                view:"credit",
                // breadcrumb:`${credit.nature} n°${credit.id}`,
                singleCredit:{credit, shop, client, sale},
            })
        }
        handleSingleShop = (shop) => {
            this.setState({
                breadcrumb: shop.name,
                singleShop:shop,
                view: "shop"
            })
        }
        handleSingleSale = (sale, shop, client) => {
            this.setState({
                view:"sale",
                breadcrumb:`${sale.nature} n°${sale.id}`,
                singleSale:{sale, shop, client},
            })
        }
        onChangePage = (pageOfItems, page, rowsPerPage) => {
            this.setState({ currentPage:page, rowsPerPage });
        }
        onChangePageSale = (pageOfItemsSale, page , rowsPerPage) => {
            this.setState({ currentPageSale:page , rowsPerPage});
        }
    render(){
        console.log("[STATE] stock ",this.state);
        let shops = this.createShopList()
        let clients = this.createClientList()

        return(
            <CardPage title="Ventes à crédit" storehouse action={
                <Box>
                    {this.state.view === "list" &&
                    <Fragment>
                        {/* <Button color="primary" variant="contained"
                            onClick={ ()=> this.setState({view: "new", breadcrumb:"Nouveau"}) }
                        >
                            Nouveau Paiement
                        </Button> */}
                        {this.state.listview === "credit" &&
                            <IconButton 
                                color="secondary"
                                title="Vue Ventes"
                                onClick={()=> this.setState({ view: "list", listview: "payList" }) }
                            >
                                <ListRounded />
                            </IconButton>
                        }
                        {this.state.listview === "payList" &&
                            <IconButton 
                            color="secondary"
                            title="Vue Paiement"
                            onClick={()=> this.setState({ view: "list", listview: "credit" }) }
                            >
                                <ListAltRounded />
                            </IconButton>
                        }
                    </Fragment>
                    }
                </Box>
            }>
                <BreadCrumb breadcrumb={ this.state.breadcrumb } title="Ventes" back={this.handleClose} />
                {this.props.STATE.credits.fetching && <Spin />}
               
                {this.state.view === "new" &&
                    <FormCredit {...this.props} close={ this.handleClose } />
                }
                {this.state.view === "credit" &&
                    <SingleSaleCredits 
                        title="Liste des paiement"
                        credit={this.state.singleCredit.credit} 
                        client={this.state.singleCredit.client} 
                        sale={this.state.singleCredit.sale}
                        {...this.props}
                        linkCreditPaymentsTo5000={this.props.linkCreditPaymentsTo5000}
                        closePopUp={() => this.setState({ view: "list", singleCredit:{
                            credit:{},
                            shop:{},
                            client:{},
                            sale:{},
                        },  }) }
                    />
                }
                {this.state.view === "sale" &&
                    <SingleTransferSale 
                        transfer={this.state.singleSale.sale} 
                        shop={this.state.singleSale.shop} 
                        client={this.state.singleSale.client} 
                        SALE_CREDITS={this.props.SALE_CREDITS}
                        CLIENTS={this.props.CLIENTS}
                        STATE={this.props.STATE}
                        linkSalesTo5000={this.props.linkSalesTo5000}
                        getIncomeInfo={this.props.getIncomeInfo}
                        {...this.props} 
                        // getPhoto={this.props.getPhoto} 
                    />
                }
                {this.state.view === "shop" &&
                    <SingleShop shop={this.state.singleShop} {...this.props} />
                }
                  
                {this.state.view === "list" &&
                // {this.state.view === "list" && (this.state.listview === "credit" ||  this.state.listview === "payList") &&
                <AccordionFilter>
                    <Grid container>
                        <Grid item xs={12} md={6}>
                            <InputSelect
                                options={shops}
                                value={this.state.selectShop}
                                label="Sélectionner un Magasin"
                                onChange={(option) => this.handleSelect(option, "selectShop") }
                            /> 
                        </Grid>
                        
                        <Grid item xs={12} md={6}>
                            <InputSelect
                                options={[
                                    {value: "", label: "Tous"},
                                    {value: "payg", label: "PayG"},
                                    {value: "vente", label: "Vente"},
                                    {value: "commercial", label: "Commercial"},
                                ]}
                                value={this.state.searchType}
                                label="Type"
                                onChange={(option) => this.handleSelect(option, "searchType") }
                            /> 
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <InputSelect
                                options={clients}
                                value={this.state.searchClient}
                                label="Client"
                                onChange={(option) => this.handleSelect(option, "searchClient") }
                            /> 
                        </Grid>
                        
                        <Grid item xs={12} md={6}>
                            <InputText
                                label="Facture"
                                value={this.state.searchFacture}
                                name="searchFacture"
                                onChange={this.handleChange}
                            /> 
                        </Grid>
                        {this.state.listview === "credit" &&
                        <Grid item xs={12} md={6}>
                            <InputSelect
                                options={[
                                    {value: "", label: "Tous les paiements"},
                                    {value: "unpointed", label: "Paiements non pointés"},
                                    {value: "pointed", label: "Paiements pointés"},
                                ]}
                                value={this.state.searchPointing}
                                label="Paiements"
                                onChange={(option) => this.handleSelect(option, "searchPointing") }
                            />
                        </Grid>
                        }
                        {this.state.listview === "credit" &&
                        <Grid item xs={12} md={6}>
                            <InputSelect
                                options={[
                                    {value: "", label: "Tous les statuts"},
                                    {value: "partial", label: "Non completement payé"},
                                    {value: "full", label: "Completement payé"},
                                ]}
                                value={this.state.searchPaymentStatus}
                                label="Etat de paiement"
                                onChange={(option) => this.handleSelect(option, "searchPaymentStatus") }
                            />
                        </Grid>
                        }
                    </Grid>
                </AccordionFilter>
                }
                {this.state.view === "list" && this.state.listview === "payList" &&
                <Box>                    
                    {!isEmpty(this.props.SALE_CREDITS) &&
                        <ListCredit 
                            {...this.props}
                            {...this.state}
                            onChangePage={this.onChangePage}
                            handleSingleShop={this.handleSingleShop}  
                            handleSingleCredit={this.handleSingleCredit}  
                            getFilteredList={this.getFilteredList}  
                        />
                    }
                </Box>
                }
                {this.state.view === "list" && this.state.listview === "credit" &&
                <Box> 
                        <ListSale 
                            {...this.props}
                            {...this.state}
                            dataview="vente"
                            onChangePage={this.onChangePageSale}
                            handleSingleShop={this.handleSingleShop}  
                            handleSingleSale={this.handleSingleSale}  
                            SALE_CREDITS={this.props.SALE_CREDITS}
                            STATE={this.props.STATE}
                            linkSalesTo5000={this.props.linkSalesTo5000}
                            unLinkSalesTo5000={this.props.unLinkSalesTo5000}
                            getIncomeInfo={this.props.getIncomeInfo}
                            showCreditPaidColumn={true}
                            getFilteredList={this.getFilteredListSale}  
                        />
                </Box>
                }
            </CardPage>
        )
    }
}

export default Credits